import Service from '@/helpers/adminService'

export default {

    index(params) {
        return Service().get('admin/blog', {params});
    },
    show(id) {
        return Service().get('admin/blog/'+id);
    },
    create(params) {
        return Service().post('admin/blog', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('admin/blog/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().delete('admin/blog/'+id);
    },
}
